/**
 * services Config File
 */
import AppConfig from './AppConfig'
export default {
	ACCOUNTS: {
		CREATE_ACCOUNTIAM: AppConfig.baseUrlIAM + '/auth/user/register',
		GET_PROFILE_IAM: AppConfig.baseUrlIAM + '/auth/user/profile',
		GET_ACCOUNTSIAM: AppConfig.baseUrlIAM + '/iam/public/profile/read',
		UPDATE_SCOPESIAM: AppConfig.baseUrlIAM + '/auth/user/scope/update',
		UPDATE_PASSWORDIAM: AppConfig.baseUrlIAM + '/auth/user/password',
		UPDATE_ACCOUNTIAM: AppConfig.baseUrlIAM + '/auth/user/profile/update',
		UPDATE_USERACCOUNTIAM: AppConfig.baseUrlIAM + '/iam/public/profile/write',
		CHECK_EMAIL_REGISTER: AppConfig.baseUrlIAM + '/auth/user/check-email'

	},
	SESSION: {
		GENERATE_TOKEN: AppConfig.baseUrlIAM + '/iam/oauth/token'
	},
	FILES: {
		UPLOAD_FILE: AppConfig.baseUrlFileServer
	},
	PUSH_NOTIFICATION: {
		ALL: '/notification/all',
		CREATE: '/notification/create',
		SEARCH: '/notification/search'
	},
	BOTON_PAGOS: {
		POST_PAYMENT: AppConfig.botonPagosBaseUrl + '/pagos/payment',
		APP_CODE: AppConfig.botonPagosAppCode,
		APP_USER: AppConfig.botonPagosAppUser,
		APP_PASS: AppConfig.botonPagosAppPass,
	},
	ASURAPI_SEGURIDAD: {
		BASE_URL: AppConfig.seguridadBaseUrl
	},
	VUE_APP_ASURAPI_SIAERP:{
		BASE_URL: AppConfig.siaerpBaseUrl

	},
	VUE_APP_ASURAPI_IAM:{
		BASE_URL: AppConfig.aimAsurApiBaseUrl

	}

}